import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import {
  faFileAlt,
  faTrashAlt,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";

const ResumeUpload = ({ userId }) => {
  const [filePath, setFilePath] = useState("");
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  // --- Функция для получения актуального файла из базы ---
  const fetchUploadedCV = () => {
    if (!userId) return;
    setLoading(true);

    fetch(`/api/get_uploaded_cv.php?user_id=${userId}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.file_path) {
          const path = data.file_path;
          const fullPath = `/api/uploads/${path}?t=${Date.now()}`;
          const name = data.cv_name || path.split("/").pop();
          
          setFilePath(fullPath);
          setFileName(name);
          
          // 🔹 Сохраняем в localStorage
          localStorage.setItem(`uploadedCV_${userId}`, JSON.stringify({
            file_path: fullPath,
            file_name: name
          }));
        } else {
          setFilePath("");
          setFileName("");
          // 🔹 Удаляем из localStorage
          localStorage.removeItem(`uploadedCV_${userId}`);
        }
      })
      .catch((err) => {
        console.error("Ошибка при получении файла:", err);
        setFilePath("");
        setFileName("");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    // 🔹 Сначала пробуем загрузить из localStorage для мгновенного отображения
    const savedData = localStorage.getItem(`uploadedCV_${userId}`);
    if (savedData) {
      try {
        const parsed = JSON.parse(savedData);
        setFilePath(parsed.file_path);
        setFileName(parsed.file_name);
      } catch (e) {
        console.error("Ошибка парсинга localStorage:", e);
      }
    }
    
    // Затем загружаем свежие данные с сервера
    fetchUploadedCV();
  }, [userId]);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("cv_file", file);

    try {
      const res = await fetch("/api/upload_cv.php", {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      console.log("Ответ от сервера:", data);

      if (data.success && data.file_path) {
        const newPath = data.file_path;
        const fullPath = `/api/uploads/${newPath}?t=${Date.now()}`;
        const name = data.cv_name || newPath.split("/").pop();
        
        setFilePath(fullPath);
        setFileName(name);
        
        // 🔹 Сохраняем в localStorage
        localStorage.setItem(`uploadedCV_${userId}`, JSON.stringify({
          file_path: fullPath,
          file_name: name
        }));
        
        // 🔹 Обновляем данные с сервера
        fetchUploadedCV();
      } else {
        console.error("Ошибка загрузки файла:", data.error);
      }
    } catch (err) {
      console.error("Ошибка при загрузке файла:", err);
    }
  };

  const handleDelete = async () => {
    try {
      const res = await fetch("/api/delete_uploaded_cv.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId }),
      });
      const data = await res.json();
      if (data.success) {
        // 🔹 Удаляем из localStorage
        localStorage.removeItem(`uploadedCV_${userId}`);
        // Обновляем состояние
        setFilePath("");
        setFileName("");
        // Обновляем с сервера
        fetchUploadedCV();
      }
    } catch (err) {
      console.error("Ошибка при удалении файла:", err);
    }
  };

  return (
    <div className="flex w-full items-center">
      {loading && !filePath ? (
        <span>Загрузка...</span>
      ) : filePath ? (
        <>
          <div className="flex w-[180px] items-center gap-2 bg-gray-700 px-3 py-2 rounded">
            <FontAwesomeIcon icon={faFileAlt} className="text-white text-xl" />
            <a
              href={filePath}
              target="_blank"
              rel="noreferrer"
              className="text-white truncate max-w-[150px]"
            >
              {fileName}
            </a>
          </div>
          <button
            onClick={handleDelete}
            className="ml-3 bg-red-600 text-white py-2 px-3 rounded hover:bg-red-700 flex items-center gap-2"
          >
            <FontAwesomeIcon icon={faTrashAlt} />
            {t("remove")}
          </button>
        </>
      ) : (
        <label className="py-2 px-4 flex justify-start items-center gap-3 cursor-pointer capitalise text-lg max-sm:text-[16px] rounded-md bg-white text-[#006674] transition-all duration-200 hover:bg-gray-200 hover:shadow-2xl hover:shadow-black w-full">
          <span>{t("UploadCV")}</span>
          <FontAwesomeIcon icon={faUpload} />
          <input 
            type="file" 
            className="hidden" 
            onChange={handleUpload}
            accept=".pdf,.doc,.docx" 
          />
        </label>
      )}
    </div>
  );
};

export default ResumeUpload;